// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3iMf5","rootCenter":"LoadMoreObserver_rootCenter__1xTcp","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1-IL7"};